import api from './api';

export const calendarService = {
  getEvents: (params = {}) => api.get('/calendar', { params }),
};
